import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useOutlets } from '@/hooks/useOutlets';
import { CashierForm } from '@/components/cashiers/CashierForm';
import type { CreateCashierRequest, UpdateCashierRequest } from '@photobooth/api-client';

export function NewCashierPage() {
  const navigate = useNavigate();
  const { outlets } = useOutlets();

  const handleCreate = async (data: CreateCashierRequest | UpdateCashierRequest) => {
    // In this page we always expect a create payload from CashierForm
    const createData = data as CreateCashierRequest;
    const response = await api.cashiers.create(createData);
    if (response.success && response.data) {
      navigate('/cashiers');
    } else {
      throw new Error(response.error?.message || 'Failed to create cashier');
    }
  };

  return (
    <div className="p-8">
      <div className="max-w-2xl mx-auto">
        <button
          onClick={() => navigate('/cashiers')}
          className="text-primary hover:underline mb-4"
        >
          ← Back to Cashiers
        </button>

        <div className="bg-surface rounded-lg shadow p-6">
          <h1 className="text-2xl font-bold text-text mb-6">Create New Cashier</h1>
          <CashierForm
            outlets={outlets}
            onSubmit={handleCreate}
            onCancel={() => navigate('/cashiers')}
          />
        </div>
      </div>
    </div>
  );
}
